﻿import {InstallationByHostData} from "../../types/InstallationByHostData";
import {TimeZone} from "../../types/TimeZone";
import IPermitsGlobal from "../IPermitsGlobal";
import {PermitsFrontClient} from "./PermitsFrontClient";

export class PermitsGlobal implements IPermitsGlobal {
	_client: PermitsFrontClient;

	constructor(client: PermitsFrontClient) {
		this._client = client;
	}

	installation(hostName: string): Promise<InstallationByHostData> {
		return this._client.jsonFetch("installations", "GET", null, {
			query: {
				"hostName": hostName
			}
		});
	}

	ping(): Promise<string> {
		return this._client.jsonFetch("ping", "GET", null, null);
	}

	timezones(): Promise<TimeZone[]> {
		return this._client.jsonFetch("timezones", "GET", null, null);
	}

	translations(installationId: string, languageId: string): Promise<Record<string, string>> {
		return this._client.jsonFetch(`translations/${installationId}`, "GET", null, {
			query: {
				"languageId": languageId
			}
		});
	}
}
